/**
 * Service for managing SEO-related utilities
 */

/**
 * Generate a canonical URL
 * @param {string} path - Current path
 * @param {string} locale - Current locale
 * @returns {string} Full canonical URL
 */
export function getCanonicalUrl(path, locale) {
  const baseUrl =
    typeof window === "undefined"
      ? (import.meta.env && import.meta.env.VITE_SITE_URL) ||
        "https://spinthenames.com"
      : window.location.hostname === "localhost"
      ? `${window.location.protocol}//${window.location.host}`
      : "https://spinthenames.com";

  // Remove locale prefix if present
  let cleanPath = path;

  // If path starts with a locale like /en-US or /fr, remove it
  const localeRegex = /^\/([a-z]{2}(-[A-Z]{2})?)(\/|$)/;
  if (localeRegex.test(path)) {
    cleanPath = path.replace(localeRegex, "/");
  }

  // Handle default locale case (might not need the locale in URL)
  if (locale === "en-US" || locale === "en") {
    return `${baseUrl}${cleanPath}`;
  }

  // For non-default locales, include the locale
  return `${baseUrl}/${locale}${cleanPath}`;
}
